import api from './api';
import { API_ENDPOINTS } from '../constants';

/** Категория: GET/POST/PATCH /api/v1/admin/categories */
export interface CategoryTreeItem {
  id: number;
  name: string;
  isVisible?: boolean;
  hasChild: boolean;
  parentCategoryId?: number | null;
  childrens?: string[];
  /** @deprecated API может отдавать children — используйте childrens */
  children?: string[];
}

export interface Category extends CategoryTreeItem {}

export interface CategoryCreateData {
  name: string;
  parentCategoryId?: number | undefined;
}

export interface CategoryUpdateData {
  name?: string;
  parentCategoryId?: number;
  isVisible?: boolean;
}

/** Ответ API GET /api/v1/admin/categories */
export interface CategoriesApiResponse {
  items: CategoryTreeItem[];
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

/** Унифицированный ответ для UI (пагинация) */
export interface CategoriesListResponse {
  data: CategoryTreeItem[];
  current_page: number;
  last_page: number;
  per_page: number;
  total?: number;
}

export const categoryService = {
  /** GET /api/v1/admin/categories — список категорий (page, limit, searchQuery) */
  getCategoriesList: async (
    page: number = 1,
    limit: number = 10,
    searchQuery?: string
  ): Promise<CategoriesListResponse> => {
    const params: { page: number; limit: number; searchQuery?: string } = { page, limit };
    if (searchQuery != null && searchQuery.trim() !== '') params.searchQuery = searchQuery.trim();
    const { data } = await api.get<CategoriesApiResponse>(API_ENDPOINTS.CATEGORIES_LIST, { params });
    return {
      data: Array.isArray(data.items) ? data.items : [],
      current_page: data.page,
      last_page: data.totalPages,
      per_page: data.pageSize,
      total: data.totalCount,
    };
  },

  /** GET /api/v1/admin/categories/{id} — категория по id */
  getCategory: async (id: number): Promise<CategoryTreeItem> => {
    const { data } = await api.get<CategoryTreeItem>(API_ENDPOINTS.CATEGORY_GET(id));
    return data;
  },

  /** POST /api/v1/admin/categories — создание категории */
  createCategory: async (data: CategoryCreateData): Promise<CategoryTreeItem> => {
    const { data: result } = await api.post<CategoryTreeItem>(API_ENDPOINTS.CATEGORIES_LIST, {
      name: data.name,
      parentCategoryId: data.parentCategoryId || undefined,
    });
    return result;
  },

  /** PATCH /api/v1/admin/categories/{id} — обновление категории */
  updateCategory: async (id: number, data: CategoryUpdateData): Promise<CategoryTreeItem> => {
    const body: Record<string, unknown> = {};
    if (data.name !== undefined) body.name = data.name;
    if (data.parentCategoryId !== undefined) body.parentCategoryId = data.parentCategoryId;
    if (data.isVisible !== undefined) body.isVisible = data.isVisible;
    const { data: result } = await api.patch<CategoryTreeItem>(API_ENDPOINTS.CATEGORY_GET(id), body);
    return result;
  },

  /** Переключение видимости категории (PATCH isVisible) */
  setCategoryVisibility: async (id: number, isVisible: boolean): Promise<CategoryTreeItem> => {
    return categoryService.updateCategory(id, { isVisible });
  },

  /** DELETE /api/v1/admin/categories/{id} — удаление категории */
  deleteCategory: async (id: number): Promise<void> => {
    await api.delete(API_ENDPOINTS.CATEGORY_GET(id));
  },

  getPromocodeTemplatesByCategory: async (id: number): Promise<{ data: any[] }> => {
    const { getMockTemplates } = await import('./mockData');
    return { data: getMockTemplates('', id) };
  },
};
